module.exports = __webpack_public_path__ + "static/hero-04-c38cb613cb769ee59df75c4b0c978bcf.jpg";